// eslint-disable-next-line import/prefer-default-export
export const ManagerPage = Object.freeze({
    None: 0,
    BiddingList: 1,
    Audit: 2,
    Archives: 3,
});
